import { render, staticRenderFns } from "./WorkBookQuestionsWithChoice.vue?vue&type=template&id=4bfc6a6c&scoped=true&"
import script from "./WorkBookQuestionsWithChoice.vue?vue&type=script&lang=js&"
export * from "./WorkBookQuestionsWithChoice.vue?vue&type=script&lang=js&"
import style0 from "./WorkBookQuestionsWithChoice.vue?vue&type=style&index=0&id=4bfc6a6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bfc6a6c",
  null
  
)

export default component.exports